<div class="switch-wrapper" name="switch" [class.switch-on]="switch" [ngClass]="customClass">
  <div class="switch-circle" name="switch" [class.switch-circle-on]="switch">
  </div>
</div>
